module.exports = __webpack_public_path__ + "img/archive.2bf5eae7.svg";